export default __webpack_public_path__ + "static/media/news.7e15642f.jpg";